/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AdminsView.vue?vue&type=template&id=38901903"
import script from "./AdminsView.vue?vue&type=script&lang=js"
export * from "./AdminsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38901903')) {
      api.createRecord('38901903', component.options)
    } else {
      api.reload('38901903', component.options)
    }
    module.hot.accept("./AdminsView.vue?vue&type=template&id=38901903", function () {
      api.rerender('38901903', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminsView.vue"
export default component.exports